import { createFileRoute } from "@tanstack/react-router";
import ThankYouConsultation from "@/pages/ThankYouConsultation";
export const Route = createFileRoute("/thank-you-consultation")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "Thank You — Consultation Requested | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Thank you for requesting a free consultation with Neuro Wellness TMS Centers of America. A member of our clinical team will contact you within one business day.",
        },
        {
          property: "og:title",
          content: "Thank You — Consultation Requested | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Thank you for requesting a free consultation with Neuro Wellness TMS Centers of America. A member of our clinical team will contact you within one business day.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/thank-you-consultation",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/thank-you-consultation",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ThankYouConsultation />;
}
